import React from "react";
import "./dataLabel.css";
export default function DataLabel(props) {
    var _a;
    const type = (_a = props.type) !== null && _a !== void 0 ? _a : "vertical";
    const data = props.children ? props.children
        : typeof props.data === "string" ? props.data
            : props.data;
    return (React.createElement("span", { className: "data-label-box " +
            (type == "vertical" || type === "vertical-no-line" ?
                "data-label-box-vertical"
                : "data-label-box-horizontal") +
            (props.importantData === true ? " data-label-box-important-data" : "") +
            (props.type === "horizontal-no-line" ?
                " data-label-box-horizontal-no-line"
                : props.type === "horizontal-fixed-label" ?
                    " data-label-box-horizontal-fixed-label"
                    : props.type === "vertical-no-line" ? " data-label-box-vertical-no-line"
                        : "") +
            (props.responsive ? " data-label-box-responsive" : "") },
        React.createElement("strong", null,
            props.label,
            ":"),
        React.createElement("span", null, data)));
}
